import { createContext, useContext, useEffect, useState } from "react";
import * as React from "react";
import { auth } from "FirebaseSetup/auth";
import PageLoader from "Components/PageLoader";
import 'firebase/compat/auth';
import { User as FirebaseUser } from "firebase/auth";
import useToasts from "../Hooks/UseToasts";
import {useTranslation} from "react-i18next";

type ContextProps = {
    firebaseUser: FirebaseUser | null,
    signIn: Function;
    resetPassword: Function;
}
export const AuthContextProvider = createContext<ContextProps>({
    firebaseUser: null,
    signIn: () => {
        throw new Error("Method not implemented")
    },
    resetPassword: () => {
        throw new Error("Method not implemented")
    }
});
interface Props {
    children: React.ReactNode;
}
const AuthProvider = (props: Props) => {

    const { t } = useTranslation();

    const { showSuccessToast, showErrorToast } = useToasts();

    const [loading, setLoading] = useState<boolean>(true);
    const [firebaseUser, setFirebaseUser] = useState<FirebaseUser | null>(null);

    useEffect(() => {
        auth.onAuthStateChanged((user: any) => {
            setFirebaseUser(user);
            setLoading(false)
        })
    }, [])
    
    const signIn = async (data: {email: string, password: string}) => {
        try {
            await auth.signInWithEmailAndPassword(data.email, data.password);
        } catch (e) {
            showErrorToast(t('invalidCredentials'));
        }
    }
    
    const resetPassword = async (data: {email: string}) => {
        try {
            await auth.sendPasswordResetEmail(data.email);
        } catch (e) {
            showErrorToast(t('anErrorOccurred'));
        }

        showSuccessToast(t('resetPasswordEmailSent'));
    }
    
    return (
        <AuthContextProvider.Provider value={{firebaseUser, signIn, resetPassword}}>
            <PageLoader shown={(loading)}>
                {props.children}
            </PageLoader>
        </AuthContextProvider.Provider>
    )
}

export default AuthProvider

export const useAuthProvider = () => {
    return useContext(AuthContextProvider);
}
